import { Injectable } from "@angular/core";
import {
  throwError as observableThrowError,
  Observable,
  BehaviorSubject,
} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import { CentralService } from "./central.service";

@Injectable({
  providedIn: "root",
})
export class AutenticarService {
  token: string;
  private UrlSrv: string = "";
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(
    this.hasValidToken(),
  );
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  private isAdminSubject = new BehaviorSubject<boolean>(this.hasAdminRole());
  public isAdmin$ = this.isAdminSubject.asObservable();

  constructor(
    private http: HttpClient,
    private srvCentral: CentralService,
  ) {}
  private hasValidToken(): boolean {
    const usuarioActual = JSON.parse(localStorage.getItem("usuarioActual"));
    this.token = usuarioActual?.token || null;
    return !!this.token && this.token !== "?";
  }

  private hasAdminRole(): boolean {
    const usuarioActual = JSON.parse(localStorage.getItem("usuarioActual"));
    return usuarioActual?.esAdmin === true;
  }

  login(usu: string, clave: string): Observable<string> {
    this.UrlSrv = this.srvCentral.UrlCave;
    usu = this.srvCentral.mete(usu);
    const clv = this.srvCentral.mete(clave);
    return this.http
      .post(
        this.UrlSrv + "/cavelogin",
        { usu: usu, clv: clv },
        { responseType: "json" },
      )
      .pipe(
        map((data) => {
          // console.log("Respuesta del servidor:", data);
          if (data[0].UsuUsu !== "?") {
            data[0].UsuUsu = this.srvCentral.saca(data[0].UsuUsu);
            data[0].UsuNom = this.srvCentral.saca(data[0].UsuNom);
            data[0].UsuClv = clave;
          }
          const nuevoToken = data[0] && data[0].UsuToken;
          const nombreUsuar = data[0].UsuNom;
          const codigoUsuario = data[0].UsuCodig;
          if (nuevoToken === "?") {
            // token inválido
            return data[0].UsuNom;
          } else {
            // console.log("que marca", nombreUsuar);
            const isAdmin = nombreUsuar === "Administrador";
            // console.log("isAdmin:", isAdmin);
            // token válido
            this.token = nuevoToken;
            localStorage.setItem(
              "usuarioActual",
              JSON.stringify({
                UsuUsu: usu,
                UsuNom: nombreUsuar,
                token: this.token,
                esAdmin: isAdmin,
                codUsu: codigoUsuario,
              }),
            );
            this.srvCentral.ponIden(data);
            this.isAuthenticatedSubject.next(true);
            this.isAdminSubject.next(isAdmin);
            return "IDENTIFICACION VALIDA";
          }
        }),

        catchError((err: any) =>
          observableThrowError(err || { message: "Error del Servidor " }),
        ),
      );
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem("usuarioActual");
    this.srvCentral.borraIden();
    this.isAuthenticatedSubject.next(false);
    this.isAdminSubject.next(false);
  }

  isLoggedIn(): boolean {
    return this.isAuthenticatedSubject.value;
  }

  isAdmin(): boolean {
    return this.isAdminSubject.value;
  }
}
